import * as React from 'react';

// Utils
import { useTranslation } from 'react-i18next';
// Constants
// Actions
// Models & Interfaces
// Components
// Styles
// Images

type Props = {
  showHotelsList: boolean;
  toggleDisplayHotelList: () => void;
};

export const HotelViewToggleButton: React.FC<Props> = ({
  showHotelsList,
  toggleDisplayHotelList,
}) => {
  const { t } = useTranslation();

  return (
    <button className="button" onClick={toggleDisplayHotelList}>
      {showHotelsList ? (
        <i className="material-symbols is--first">distance</i>
      ) : (
        <i className="material-symbols">format_list_bulleted</i>
      )}
      {t(`HotelsConn.header.mobileLabel.${showHotelsList ? 'showMap' : 'showList'}`)}
    </button>
  );
};
